import { BookingItem } from "./BookingItem";

interface BookingListProps {
  bookings: any[];
  onApprove: (id: string) => void;
  onReject: (id: string) => void;
  processingId: string | null;
}

export const BookingList = ({ 
  bookings, 
  onApprove, 
  onReject, 
  processingId 
}: BookingListProps) => {
  if (!bookings || bookings.length === 0) {
    return (
      <p className="text-center text-muted-foreground py-8">
        No pending bookings to review
      </p>
    );
  }

  return (
    <div className="space-y-4">
      {bookings.map((booking) => (
        <BookingItem
          key={booking.id}
          booking={booking}
          onApprove={onApprove}
          onReject={onReject}
          processingId={processingId}
        />
      ))}
    </div>
  );
};